/// <amd-module name="TFS/Token/PatTokenPage/Context/AccountNameContext" />
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPatPageContextValue, PatPageConsumer } from 'Context/PatPageContext';
import { IVssContributionService } from 'VSS/Platform/Contribution';

export interface IAccountNameContextValue {
    readonly accountIdToNameMap?: { [accountId: string]: string };
    readonly accounts?: { accountId: string, accountName: string }[];
}

const AccountNameContext = React.createContext<IAccountNameContextValue>(undefined as never);

export interface IAccountNameProviderProps { };

export interface IAccountNameProviderInternalProps extends IAccountNameProviderProps {
    pageContext: IVssPageContext;
}

export class AccountNameProviderInternal extends React.PureComponent<IAccountNameProviderInternalProps, {}> {
    private readonly getAllAccountNameDataProviderContributionId = "ms.vss-token-web.personal-access-token-account-names-provider";
    private accountIdToNameMap: { [accountId: string]: string } = {};
    public componentDidMount() {
        this.setAccountIdToNameMap();
    }

    public render(): JSX.Element {
        return (
            <AccountNameContext.Provider
                value={{
                    accountIdToNameMap: this.accountIdToNameMap,
                    accounts: this.accountPairList
                } as IAccountNameContextValue}
            >
                {this.props.children}
            </AccountNameContext.Provider>);
    }

    private setAccountIdToNameMap = async () => {
        const vssContributionService = this.props.pageContext.getService<IVssContributionService>("IVssContributionService");
        const accountNameToIdMapResult: { [accountId: string]: string } | undefined = await vssContributionService
            .getDataAsync<{ [accountId: string]: string }>(this.getAllAccountNameDataProviderContributionId, {}, true);
        if (accountNameToIdMapResult) {
            this.accountIdToNameMap = accountNameToIdMapResult;
            this.forceUpdate();
        }
    }

    private get accountPairList(): { accountId: string, accountName: string }[] {
        let accounts: { accountId: string, accountName: string }[] = [];
        if (this.accountIdToNameMap) {
            const accountIds = Object.keys(this.accountIdToNameMap);
            accounts = accountIds.map((accountId) => {
                return {
                    accountId,
                    accountName: this.accountIdToNameMap[accountId],
                }
            });
        }
        return accounts;
    }
}

export const AccountNameProvider = (props: IAccountNameProviderProps) =>
    <PatPageConsumer>
        {(patPageContext: IPatPageContextValue) =>
            <AccountNameProviderInternal
                {...props}
                pageContext={patPageContext.pageContext}
            />}
    </PatPageConsumer>;


export const AccountNameConsumer = AccountNameContext.Consumer;

